import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicLaplaceODE = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="SOLVING ODEs USING LAPLACE TRANSFORM"
      videos={[
        "https://www.youtube.com/embed/KaRx67h5xzk?list=PLU6SqdYcYsfIWugLkTq1nMoU3rDDx7xpG"
      ]}
      takeaways={[
        {text:"Sample question",
        image:"/sde_1.png"},
        {image:"/sde_2.png"},
        {text:"Questions",
          image:"/sde_3.png"
        }
        
      ]}
      questions={[]}
      exampleVideos={[]}
    />
);
}

export default ModuleSubtopicLaplaceODE;